import {Route, Switch, useRouteMatch,Redirect} from "react-router-dom";
import Miaging from "./miAging";
import MiApply from "./miApply";
import OrderDetail from "./orderDetail";
import FinanSchedule from "./finanSchedule";
import ApplyDetail from "./applyDetail";
import LoanDetail from "./loanDetail";

export default function () {
  const {path} = useRouteMatch()
  return <Switch>
    <Route path={`${path}/`} exact component={Miaging}/>
    {/* 分期申请 */}
    <Route path={`${path}/miApply`} component={MiApply}/>
    {/* 分期申请详情 */}
    <Route path={`${path}/orderDetail`} component={OrderDetail}/>
    {/* 金融方案 */}
    <Route path={`${path}/finanSchedule`} component={FinanSchedule}/>
    {/*我的金融方案  */}
    <Route path={`${path}/applyDetail`} component={ApplyDetail}/>
    {/* 我的融租合同 */}
    <Route path={`${path}/loanDetail`} component={LoanDetail}/>
    <Redirect to={`${path}/`} />
</Switch>
}